import { getServiceName, ServiceName } from "src/utils/getservicename";
import { RunningAnobisMode } from "../config";

export function IsTabHidden(isHidden, selectedTab) {
  const tabsToHide = findZeroIndices(isHidden);
  return tabsToHide.includes(selectedTab);
}

function findZeroIndices(input: string): string[] {
  // Validate the input to ensure it's a 4-digit string containing only 1 and 0
  if (input.length !== 4 || !/^[01]+$/.test(input)) {
    return [];
  }

  const indices: string[] = [];

  let filterTab = ["Today", "Yesterday", "Last 7 days", "Last 4 weeks"];
  if (getServiceName() === ServiceName.ANOBIS_IMCOM) {
    filterTab = RunningAnobisMode.SHOW_IM_COM_TIME_TAB;
  } else if (getServiceName() === ServiceName.ANOBIS_INDIA_2) {
    filterTab = RunningAnobisMode.INDIA_2_MIS_TIME_TAB;
  }

  // Iterate through the string and find the indices with '0'
  for (let i = 0; i < input.length; i++) {
    if (input[i] === "0") {
      indices.push(filterTab[i]);
    }
  }

  return indices;
}
